
import { crudObjectReducer, removeFromObject, editToObjectDump, editArrayToObjectDump } from '../utils/crud-reducer';
import { CREATE_ITEM, EDIT_ITEM, EDIT_ITEMS, REMOVE_ITEM } from '../reducers/item.reduce';
/**
 * ACCOUNT_ACTIVE sets
 * ACCOUNT_CLEAR logs out the user 
 * //sending an account as argument will attempt to connect that user
 * @param {} state 
 * @param {*} action 
 */

//Selectors 
export const getBeddings = state => state.bedding;
export const getBeddingById = (state, id) =>
  getBeddings(state).find(ac => ac.id === id);

const beddings = crudObjectReducer('bedding', {
  [CREATE_ITEM]: editToObjectDump,
  [EDIT_ITEM]: editToObjectDump,
  [EDIT_ITEMS]: editArrayToObjectDump,
  [REMOVE_ITEM]: removeFromObject
});

export default beddings
